import React from "react"

import { Link } from "gatsby"

// Props: id, title, image?, tags?,

const PuzzleCard = ({ puzzle }) => {
  return (
    <div className="card">
      <div className="card-image">
        <Link to={"/puzzles/view?p=" + puzzle.puzzleId}>
          <figure className="image is-4by3">
            <img src={puzzle.imageCdnUrl || "https://cdn.jiggswap.com/assets/placeholder.png"} alt={puzzle.title} />
          </figure>
        </Link>
      </div>
      <div className="card-content">
        <div className="has-text-centered">
          {puzzle.title.substring(0, 30)}
          {puzzle.title.length > 30 && "…"}
        </div>
        <div className="has-text-centered">{puzzle.numPieces} pcs</div>

        {/*         <div style={{ height: "40px", marginTop: "15px", overflow: "hidden" }}>{/*<TagList tags={puzzle.tags} /> </div>*/}
      </div>
      <div className="card-footer">
        <Link to={"/puzzles/view?p=" + puzzle.puzzleId} className="button is-primary card-footer-item">
          <i className="fas fa-search mr-1"></i>View Details
        </Link>
      </div>
    </div>
  )
}

export default PuzzleCard
